
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 513 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 0h512v342H0z"}}),_c('path',{attrs:{"fill":"#338AF3","d":"M0 0h512v114H0zM0 228h512v114H0z"}}),_c('circle',{attrs:{"fill":"#FFDA44","stroke":"#d6ab00","stroke-width":"5","cx":"256.5","cy":"171","r":"40"}})])
          )
        }
      }
    